import { referenceDataApi } from './endpoints';

const getReferenceData = () => referenceDataApi.get('referencedata');

export { getReferenceData }
